export default function ProductGrid() {
  const products = [
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/778121/12/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "Fenerbahçe S.K. Erkek Antrenman Forması",
      price: "855,00 ₺",
      oldPrice: "1.900,00 ₺",
      discount: "%55 İndirim"
    },
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/775360/01/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "Fenerbahçe S.K. 24/25 ERKEK İÇ SAHA FORMASI",
      price: "1.949,35 ₺",
      oldPrice: "2.999,00 ₺",
      discount: "%35 İndirim"
    },
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/778156/12/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "Fenerbahçe S.K. Erkek Antrenman Eşofman Altı",
      price: "1.440,00 ₺",
      oldPrice: "3.200,00 ₺",
      discount: "%55 İndirim"
    },
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/778120/09/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "Fenerbahçe S.K. 24/25 Erkek Antrenman Ceketi",
      price: "2.249,55 ₺",
      oldPrice: "4.999,00 ₺",
      discount: "%55 İndirim"
    },
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/778123/12/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "FENERBAHÇE S.K. ERKEK ÇEYREK FERMUARLI ANTRENMAN ÜSTÜ",
      price: "1.395,00 ₺",
      oldPrice: "3.100,00 ₺",
      discount: "%55 İndirim"
    },
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/396464/07/sv01/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "Palermo Deri Ayakkabı",
      price: "1.889,65 ₺",
      oldPrice: "5.399,00 ₺",
      discount: "%65 İndirim"
    },
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/775382/09/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "Fenerbahçe S.K. 24/25 ERKEK İÇ SAHA ŞORT",
      price: "879,45 ₺",
      oldPrice: "1.599,00 ₺",
      discount: "%45 İndirim"
    },
    {
      image: "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,e_sharpen/global/775382/04/fnd/TUR/w/250/h/250/1000/fmt/png",
      name: "Fenerbahçe S.K. 24/25 ERKEK İÇ SAHA ŞORT",
      price: "879,45 ₺",
      oldPrice: "1.599,00 ₺",
      discount: "%45 İndirim"
    }
  ];

  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold mb-8">EN ÇOK SATANLAR</h2>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {products.map((product, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="relative overflow-hidden mb-3 bg-gray-50">
                {product.discount && (
                  <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 z-10">
                    {product.discount}
                  </div>
                )}
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="text-sm mb-2 line-clamp-2 min-h-[40px]">{product.name}</h3>
              <div className="flex flex-col gap-1">
                <span className="text-lg font-bold">{product.price}</span>
                {product.oldPrice && (
                  <span className="text-sm text-gray-500 line-through">{product.oldPrice}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
